import React, { useEffect, useRef, useState } from 'react';

import Button from '../components/Button';
import ReplaceableContent from '../components/ReplaceableContent';
import InfoCard from '../components/InfoCard';
import RevolvingWords from '../components/RevolvingWords';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HomeCopy = () => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const mountRef = useRef(null);
  const contentRef1 = useRef(null);
  const contentRef2 = useRef(null);
  const contentRef3 = useRef(null);
  const [matchedHeight, setMatchedHeight] = useState(null);

  useEffect(() => {
    const resize = () => {
      const height1 = contentRef1.current?.offsetHeight || 0;
      const height2 = contentRef2.current?.offsetHeight || 0;
      const height3 = contentRef3.current?.offsetHeight || 0;
      const maxHeight = Math.max(height1, height2, height3);
      setMatchedHeight(maxHeight);
    };

    // Delay slightly to let rendering settle
    const timeout = setTimeout(resize, 100);

    // Clean up
    return () => clearTimeout(timeout);
  }, [showSuccessMessage]);

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = {
      name: event.target.name.value,  
      email: event.target.email.value,
    };

    try {
      await fetch('https://script.google.com/macros/s/AKfycbxgfNvHTuIFNnyHxyBn_qn_4qv1ZmPGWk90IQQGKcPwRpJtkz-K3QXwe69AZd4GnxNz/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      setShowSuccessMessage(true);
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 3000);
    } catch (error) {
      console.error('Error submitting form', error);
    }
  };

  const formMessage = (
    <form style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1rem', // Adds space between elements
      width: '100%',
    }}>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '80%',
        margin: '0 auto',
        textAlign: 'left',
      }}>*Name:
        <input type="text" 
        name="name" 
        placeholder="e.g., Jane Doe" 
        required 
        style={{
          fontSize: '1rem',
          width: 'calc(100% - 1rem - 2px)',
          alignItems: 'center',
          padding: '0.5rem',
          marginTop: '0.5rem',
          borderRadius: '5px',
          border: '1px solid #ccc',
        }}/>
      </label>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '0 auto',
        textAlign: 'left',
        width: '80%',
      }}>*Email:
        <input type="email" 
        name="email" 
        placeholder='e.g., joeblow@gmail.com' 
        required 
        onKeyDown={(e) => {
          // Prevent the user from pressing the spacebar
          if (e.key === ' ') e.preventDefault();
        }}
        onChange={(e) => {
          // Remove any spaces (in case of copy/paste)
          e.target.value = e.target.value.replace(/\s+/g, '');
        }}
        style={{
          fontSize: '1rem',
          width: 'calc(100% - 1rem - 2px)',
          padding: '0.5rem',
          marginTop: '0.5rem',
          borderRadius: '5px',
          border: '1px solid #ccc',
        }}
      />
      </label>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '0 auto',
        textAlign: 'left',
        width: '80%',
      }}>Message:
        <textarea name="message" placeholder="Write your message here..." style={{
          fontSize: '1rem',
          width: 'calc(100% - 1rem - 2px)',
          padding: '0.5rem',
          marginTop: '0.5rem',
          borderRadius: '5px',
          border: '1px solid #ccc',
          resize: 'none',
          height: '100px', // Set height for the textarea
        }} />
      </label>
      <Button label="Submit" type="Submit" />
    </form>
  );

  const formSimple = (
    <form onSubmit={handleSubmit} style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1rem', // Adds space between elements
      width: '100%',
    }}>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '80%',
        margin: '0 auto',
        textAlign: 'left',
      }}>*Name:
      <input type="text" 
      name="name" 
      placeholder="e.g., Jane Doe" 
      required 
      style={{
        fontSize: '1rem',
        width: 'calc(100% - 1rem - 2px)',
        alignItems: 'center',
        padding: '0.5rem',
        marginTop: '0.5rem',
        borderRadius: '5px',
        border: '1px solid #ccc',
      }}/></label>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '0 auto',
        textAlign: 'left',
        width: '80%',
      }}>*Email:<input 
      type="email" 
      name="email" 
      placeholder='e.g., joeblow@gmail.com' 
      required 
      onKeyDown={(e) => {
        // Prevent the user from pressing the spacebar
        if (e.key === ' ') e.preventDefault();
      }}
      onChange={(e) => {
        // Remove any spaces (in case of copy/paste)
        e.target.value = e.target.value.replace(/\s+/g, '');
      }}
      style={{
        fontSize: '1rem',
        width: 'calc(100% - 1rem - 2px)',
        padding: '0.5rem',
        marginTop: '0.5rem',
        borderRadius: '5px',
        border: '1px solid #ccc',
      }}/></label>
      <Button label="Submit" type="Submit" />
    </form>
  );

  const formComplex = (
    <form onSubmit={handleSubmit} style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1rem', // Adds space between elements
      width: '100%',
    }}>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '80%',
        margin: '0 auto',
        textAlign: 'left',
      }}>*Name:
        <input 
        type="text" 
        name="name" 
        placeholder="e.g., Jane Doe" 
        required 
        style={{
          fontSize: '1rem',
          width: 'calc(100% - 1rem - 2px)',
          alignItems: 'center',
          padding: '0.5rem',
          marginTop: '0.5rem',
          borderRadius: '5px',
          border: '1px solid #ccc',
        }} />
      </label>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '0 auto',
        textAlign: 'left',
        width: '80%',
      }}>*Email:
        <input 
        type="email" 
        name="email" 
        placeholder='e.g., joeshmo@gmail.com' 
        required 
        onKeyDown={(e) => {
          // Prevent the user from pressing the spacebar
          if (e.key === ' ') e.preventDefault();
        }}
        onChange={(e) => {
          // Remove any spaces (in case of copy/paste)
          e.target.value = e.target.value.replace(/\s+/g, '');
        }}
        style={{
          fontSize: '1rem',
          width: 'calc(100% - 1rem - 2px)',
          padding: '0.5rem',
          marginTop: '0.5rem',
          borderRadius: '5px',
          border: '1px solid #ccc',
        }} />
      </label>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '0 auto',
        textAlign: 'left',
        width: '80%',
      }}>*Company Name:
        <input 
        type="text" 
        name="companyName" 
        placeholder="e.g., Acme Corp" 
        required 
        style={{
          fontSize: '1rem',
          width: 'calc(100% - 1rem - 2px)',
          padding: '0.5rem',
          marginTop: '0.5rem',
          borderRadius: '5px',
          border: '1px solid #ccc',
        }} />
      </label>
      <label style={{ 
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '0 auto',
        textAlign: 'left',
        width: '80%',
      }}>Message:
        <textarea name="message" placeholder="Write your message here..." style={{
          fontSize: '1rem',
          width: 'calc(100% - 1rem - 2px)',
          padding: '0.5rem',
          marginTop: '0.5rem',
          borderRadius: '5px',
          border: '1px solid #ccc',
          resize: 'none',
          height: '100px', // Set height for the textarea
        }} />
      </label>
      <Button label="Submit" type="Submit" />
    </form>
  );

  return (
    <div
    style={{
      position: 'relative',
      width: '100%',
      minHeight: '100vh',
      backgroundColor: '#000000',
    }}
  >
    <Header/>
    <div ref={mountRef} style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    }} />

      <div style={{
        position: 'relative',
        top: 0,
        left: 0,
        maxWidth: '1264px',
        margin: '0 auto', 
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2,
        fontFamily: '"Inter", system-ui, sans-serif',
        color: '#ffffff',
        padding: '0 20px',
        boxSizing: 'border-box',
        textAlign: 'center',
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          gap: '1rem', 
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '15rem 0 13rem 2rem',
          }}>
            <h1 className='huge-title' style={{
              textTransform: 'uppercase',
              textAlign: 'left',
              letterSpacing: '0.1rem',
              color: '#ffffff',
              fontWeight: 'bold',
            }}>
              We help anyone
            </h1>
            <h1 className='huge-title' style={{
              lineHeight: '1.6',
              color: '#f09eff',
              textAlign: 'left',
            }}>
              Do Quantum <RevolvingWords words={['', 'NLP', 'Cryptography', 'Chemistry']} />
            </h1>

          </div>
          {/**
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: '0.1rem',
            marginBottom: '0.5rem',
          }}>
            What We Do
          </h1>
          **/}
          <div style={{
            display: 'flex',
            gap: '1rem',
            flexWrap: 'wrap',
            justifyContent: 'center',
            maxWidth: '1200px',
            margin: '0 auto',
          }}>
            {/**
            <InfoCard
              title="Research Track"
              subtitle="We serve:"
            >
              <ReplaceableContent
                title="UMD Students"
                content={
                  <p>
                    Start with just Python knowledge. We'll help you build expertise in Quantum ML, NLP, and cryptography through interactive learning, do research, get an advisor, and publish your work.
                  </p>
                }
                form={formSimple}
                buttonLabel="Join Waitlist"
                showSuccessMessage={showSuccessMessage}
              />

              <ReplaceableContent
                title="UMD Professors"
                content={
                  <p>
                    Share your expertise as a research advisor and publish faster. Choose your projects, set your availability, and guide the next generation of quantum researchers for as little as 1hr/week.
                  </p>
                }
                form={formMessage}
                buttonLabel="Apply to Advise"
                showSuccessMessage={showSuccessMessage}
              />
            </InfoCard>
            **/}

            <InfoCard
              title="We maintain"
            >
              <ReplaceableContent
                ref={contentRef1}
                style={{ height: matchedHeight, minWidth: '250px' }}
                title="Chapter Network"
                content="We facilitate research programs with 100% acceptance rates while maintaining excellence."
                form={null}
                buttonLabel="See Current Chapter"
              >
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                  <img
                    src="/umd-circle.png"
                    alt="University of Maryland"
                    style={{
                      width: '50%',
                      height: 'auto',
                      borderRadius: '1rem',
                      marginBottom: '1rem',
                    }}
                  />
                  <p className="big-content-text" style={{ textAlign: 'center', marginTop: '1rem'  }}>
                    We are currently working with the University of Maryland, but we are expanding to other universities.
                  </p>
                </div>
              </ReplaceableContent>

            </InfoCard>

            <InfoCard
              title="We conduct"
            >
              <ReplaceableContent
                ref={contentRef2}
                style={{ height: matchedHeight, minWidth: '250px' }}
                title="Research Projects"
                content="Quantum doesn't just happen in a lab. We conduct a range of research that is relevant to many industries."
                buttonLabel="See Research Projects"
              >
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '1.5rem',
                }}>
                  {/* Icon Grid */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem' }}>
                      <img src="/chat-bot.png" alt="Quantum Natural Language Processing" style={{ width: '50px', height: '50px' }} />
                      <img src="/virus.png" alt="Quantum Chemistry" style={{ width: '50px', height: '50px' }} />
                      <img src="/cyber-security.png" alt="Quantum Cryptography" style={{ width: '50px', height: '50px' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem' }}>
                      <img src="/quantum-computing.png" alt="Quantum Hardware" style={{ width: '50px', height: '50px' }} />
                      <img src="/stats.png" alt="Finance" style={{ width: '50px', height: '50px' }} />
                    </div>
                  </div>

                  {/* Bottom Text */}
                  <p className="big-content-text" style={{ textAlign: 'center', marginTop: '1rem' }}>
                    Just a few of the industries we touch.
                  </p>
                </div>
              </ReplaceableContent>
            </InfoCard>

            <InfoCard title="We Host">
  <ReplaceableContent
    ref={contentRef3}
    style={{ height: matchedHeight, minWidth: '250px' }}
    title="Custom Workshops"
    content="Custom, expert-led training sessions on quantum topics for any technical background and industry."
    buttonLabel="See Workshop Process"
  >
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1rem',
    }}>
      <img
        src="/deliver.JPG"
        alt="Workshop Preview"
        style={{
          width: '100%',
          borderRadius: '1rem',
          border: '1px solid rgba(255,255,255,0.1)',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
        }}
      />
      <p className="big-content-text" style={{ textAlign: 'center'}}>
        We design and deliver workshops for your goals.
      </p>
    </div>
  </ReplaceableContent>
</InfoCard>


          </div>

          <div style={{
            display: 'flex',
            gap: '1rem',
            flexWrap: 'wrap',
            justifyContent: 'center',
            margin: '0 auto',
            maxWidth: '1200px',
          }}>
            <InfoCard
            title="In our first 3 months"
            subtitle="We've Achieved"
            style={{maxWidth: '100%', minWidth: '300px',}}
          >
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: '2rem',
                padding: '2rem',
                backgroundColor: 'rgba(99, 102, 241, 0.05)',
                borderRadius: '1rem',
                textAlign: 'center',
              }}
            >
              <div style={{ flex: '1 1 180px', maxWidth: '220px' }}>
                <h3 className='emphasize-text'>300+</h3>
                <p className='big-content-text'>
                  <a href="/chapters/umd#discord" className="link-text">Students in our Do Quantum @ UMD Discord ↗</a>
                </p>
              </div>
              <div style={{ flex: '1 1 180px', maxWidth: '220px' }}>
                <h3 className='emphasize-text'>50</h3>
                <p className='big-content-text'>
                  <a href="/chapters/umd#get-involved" className="link-text">Students in Research Track ↗</a>
                </p>
              </div>
              <div style={{ flex: '1 1 180px', maxWidth: '220px' }}>
                <h3 className='emphasize-text'>5</h3>
                <p className='big-content-text'>
                  <a href="/chapters/umd#workshops" className="link-text">Weekly Workshops Led ↗</a>
                </p>
              </div>
              <div style={{ flex: '1 1 180px', maxWidth: '220px' }}>
                <h3 className='emphasize-text'>11</h3>
                <p className='big-content-text'>
                  <a href="/projects" className="link-text">Active Research Projects ↗</a>
                </p>
              </div>
              <div style={{ flex: '1 1 180px', maxWidth: '220px' }}>
                <h3 className='emphasize-text'>2</h3>
                <p className='big-content-text'>Industry Partnerships</p>
              </div>
            </div>
          </InfoCard>

          {/**
          </div>
            <h1 style={{
              fontSize: '2.5rem',
              fontWeight: 'bold',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: '0.1rem',
              marginBottom: '0.5rem',
            }}>
              Meet Our Team
            </h1>
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              margin: '0 auto',
              gap: '2rem',
              padding: '2rem',
              backgroundColor: '#100F1C',
            }}>
            <div style={{
              maxWidth: '300px',
              textAlign: 'center',
              backgroundColor: 'rgba(99, 102, 241, 0.1)',
              borderRadius: '1rem',
              padding: '1.5rem',
              border: '1px solid rgba(99, 102, 241, 0.2)',
              color: '#ffffff',
            }}>
              <img
                src="/evren-pic.png"
                alt="Team Member 1"
                style={{
                  width: '200px',
                  height: '200px',
                  borderRadius: '50%',
                  marginBottom: '1rem',
                  border: '3px solid #DC66FF',
                }}
              />
              <h3 style={{
                fontSize: '1.5rem',
                marginBottom: '0.5rem',
                color: '#ffffff',
              }}>
                Evren Yücekuş~Kissane
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#a5b4fc',
                marginBottom: '1rem',
              }}>
                Founder & CEO
              </p>
              <p style={{
                fontSize: '0.9rem',
                color: '#ffffff',
                lineHeight: '1.6',
              }}>
                Evren has conducted and presented quantum Machine Learning (ML) and Natural Language Processing (NLP) research. He holds 3+ years of experience in software development with a focus on ML and NLP and has 2+ years of experience in R&D at global pharmaceutical companies.
              </p>
            </div>

            <div style={{
              maxWidth: '300px',
              textAlign: 'center',
              backgroundColor: 'rgba(99, 102, 241, 0.1)',
              borderRadius: '1rem',
              padding: '1.5rem',
              border: '1px solid rgba(99, 102, 241, 0.2)',
              color: '#ffffff',
            }}>
              <img
                src="/wilson.jpg"
                alt="Team Member 2"
                style={{
                  width: '200px',
                  height: '200px',
                  borderRadius: '50%',
                  marginBottom: '1rem',
                  border: '3px solid #DC66FF',
                }}
              />
              <h3 style={{
                fontSize: '1.5rem',
                marginBottom: '0.5rem',
                color: '#ffffff',
              }}>
                Wilson Smith
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#a5b4fc',
                marginBottom: '1rem',
              }}>
                Executive Vice President
              </p>
              <p style={{
                fontSize: '0.9rem',
                color: '#ffffff',
                lineHeight: '1.6',
              }}>
                Wilson holds B.S. degrees in Mathematics and Computer Science and has conducted research on quantum algorithms. He has built strong relationships with academic and industry experts worldwide and has a deep understanding of quantum history and current events.
              </p>
            </div>
            **/}
          </div>
        </div>
      </div>
      <Footer/>  
    </div>
  );
};

export default HomeCopy;